<template>
    <div class="timeCom">
        <div :style="{
                color:config.color,
                fontFamily:config.fontFamily,
                fontSize:config.fontSize +'px',
                fontWeight:config.fontWeight,
                textAlign:config.align,
                border:'none',
                lineHeight:trans.height +'px',
               }">
            <span v-if="nowTimesShow.nn">{{nowTimes.nn}}</span>
            <span v-if="nowTimesShow.nn">{{nowTimesStyle.nn}}</span>
            <span v-if="nowTimesShow.yy">{{nowTimes.yy}}</span>
            <span v-if="nowTimesShow.yy">{{nowTimesStyle.yy}}</span>
            <span v-if="nowTimesShow.dd">{{nowTimes.dd}}</span>
            <span v-if="nowTimesShow.dd">{{nowTimesStyle.dd}}</span>
            <span v-if="nowTimesShow.hou">{{nowTimes.hou}}</span>
            <span v-if="nowTimesShow.hou">{{nowTimesStyle.hou}}</span>
            <span v-if="nowTimesShow.min">{{nowTimes.min}}</span>
            <span v-if="nowTimesShow.min">{{nowTimesStyle.min}}</span>
            <span v-if="nowTimesShow.sec">{{nowTimes.sec}}</span>
            <span v-if="nowTimesShow.sec && config.style === 'chsChar'">{{nowTimesStyle.sec}}</span>
            <span>&nbsp</span>
            <span v-if="nowTimesShow.xq">{{nowTimes.xq}}</span>
        </div>
    </div>
</template>

<script>
    /**
     @author xcf
     @date 2020/6/29 3:57 下午
     */
    export default {
        name: 'timeComp',
        components: {},
        props: {
            id: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
            option: {
                type: Object,
                default: ''
            },
            trans: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                nowTimes: {
                    xq: '一',
                    nn: '0',
                    yy: 0,
                    dd: "00",
                    hou: "00",
                    min: "00",
                    sec: "00"
                },
                nowTimesShow: {
                    xq: true,
                    nn: true,
                    yy: true,
                    dd: true,
                    hou: true,
                    min: true,
                    sec: true
                },
                nowTimesStyle: {
                    nn: '年',
                    yy: '月',
                    dd: '日',
                    hou: '时',
                    min: '分',
                    sec: '秒'
                },
            }
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.option.setting.params;
                }
            },
        },
        methods: {
            setNowTimes() {
                let myDate = new Date();
                this.nowTimes.xq = myDate.getDay();
                switch (this.nowTimes.xq) {
                    case 1:
                        this.nowTimes.xq = '星期一';
                        break;
                    case 2:
                        this.nowTimes.xq = '星期二';
                        break;
                    case 3:
                        this.nowTimes.xq = '星期三';
                        break;
                    case 4:
                        this.nowTimes.xq = '星期四';
                        break;
                    case 5:
                        this.nowTimes.xq = '星期五';
                        break;
                    case 6:
                        this.nowTimes.xq = '星期六';
                        break;
                    case 0:
                        this.nowTimes.xq = '星期日';
                        break;
                }
                this.nowTimes.nn = myDate.getFullYear();
                this.nowTimes.yy = myDate.getMonth() + 1;
                this.nowTimes.dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate());
                this.nowTimes.hou = String(myDate.getHours() < 10 ? "0" + myDate.getHours() : myDate.getHours());
                this.nowTimes.min = String(myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes());
                this.nowTimes.sec = String(myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds());
            },
        },
        mounted() {
            setInterval(() => {
                this.setNowTimes();
            }, 1000)
        },
        watch: {
            config(a) {
                for (let s in this.nowTimesShow) {
                    this.nowTimesShow[s] = false;
                }
                a.timeList.map((val, index) => {
                    if (val === '周') {
                        this.nowTimesShow.xq = true
                    }
                    if (val === '年') {
                        this.nowTimesShow.nn = true
                    }
                    if (val === '月') {
                        this.nowTimesShow.yy = true
                    }
                    if (val === '日') {
                        this.nowTimesShow.dd = true
                    }
                    if (val === '时') {
                        this.nowTimesShow.hou = true
                    }
                    if (val === '分') {
                        this.nowTimesShow.min = true
                    }
                    if (val === '秒') {
                        this.nowTimesShow.sec = true
                    }
                })
                if (a.style === 'chsChar') {
                    this.nowTimesStyle.xq = '周',
                        this.nowTimesStyle.nn = '年',
                        this.nowTimesStyle.yy = '月',
                        this.nowTimesStyle.dd = '日',
                        this.nowTimesStyle.hou = '时',
                        this.nowTimesStyle.min = '分',
                        this.nowTimesStyle.sec = '秒'
                } else if (a.style === 'Slash') {
                    for (let ss in this.nowTimesStyle) {
                        this.nowTimesStyle[ss] = '/';
                    }
                } else if (a.style === 'Dash') {
                    for (let sd in this.nowTimesStyle) {
                        this.nowTimesStyle[sd] = '-';
                    }
                } else if (a.style === 'Space') {
                    for (let sk in this.nowTimesStyle) {
                        this.nowTimesStyle[sk] = '  ';
                    }
                }
            },
        },
        destroyed() {
        }
    }
</script>

<style lang="less">
    .timeCom {
        > div {
            width: 100%;
            height: 100%;
            background-size: 100% 100% !important;

            > span {
                font-weight: inherit;
            }
        }
    }
</style>
